import React from 'react';
import LazyLoadedComponent from '../lazy-loaded-component/LazyLoadedComponent';
import { imageWithPrefix } from '../../scripts/helpers';
import UsMap from './graphic-us-map';
import './boost-map.scss';
type BoostMapProps = {
  className?: string;
};
interface IBoostOption {
  boost: string;
  telcom: string;
  utility: string;
  rental: string;
  bank: string;
  scoreInitial: string;
  scoreUpgraded: string;
  city: string;
  state: string;
  stateAbbr: string;
  bgState: string;
  bgColor: string;
}
type BoostMapState = {
  boost: IBoostOption;
  in: boolean;
};
class BoostMap extends React.Component<BoostMapProps, BoostMapState> {
  constructor(props: BoostMapProps) {
    super(props);
    this.onLoad = this.onLoad.bind(this);
  }

  getBoostElementIndex(max: number) {
    return Math.floor(Math.random() * max);
  }
  updateMap(arr: IBoostOption[]) {
    const b = arr[this.getBoostElementIndex(arr.length - 1)];
    b.bgColor = b.scoreInitial
      ? b.scoreInitial !== b.scoreUpgraded
        ? 'bg-secondary-c'
        : 'bg-primary-c'
      : 'bg-sapphire-c';
    b.bgState = imageWithPrefix(`/graphics/us-states/${b.stateAbbr}.svg`);
    const $map = document.getElementById('graphic-us-map');
    if ($map && $map.children.length) {
      for (var i = 0; i < $map.children.length; i++) {
        $map.children[i].classList.remove('map-fill');
      }
    }
    this.setState(
      {
        in: true,
        boost: b,
      },
      () => {
        if (b && document.getElementById(b.stateAbbr)) {
          document.getElementById(b.stateAbbr).classList.add(...['map-fill']);
        }
        this.runMap(arr);
      },
    );
  }
  runMap(arr: IBoostOption[]) {
    setTimeout(() => {
      this.setState({
        in: false,
      });
      setTimeout(() => {
        this.updateMap(arr);
      }, 500);
    }, 5000);
  }
  async onLoad() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      try {
        const response = await fetch(`https://assets.experiancs.com/data/boost.json`);
        const data = await response.json();
        const arr: IBoostOption[] = data.data;
        this.updateMap(arr);
      } catch (err) {}
    }
  }
  render() {
    const cl = this.props.className || '';
    const setCircleColor = (score: string) => {
      let bgColor = '';
      switch (score) {
        case 'Poor':
          bgColor = 'bg-red';
          break;
        case 'Fair':
          bgColor = 'bg-orange';
          break;
        case 'Good':
          bgColor = 'bg-yellow';
          break;
        case 'Very Good':
          bgColor = 'bg-green';
          break;
        default:
          bgColor = 'bg-dark-green';
      }

      return bgColor;
    };
    return (
      <LazyLoadedComponent
        id="boost-map"
        as="div"
        className={`${cl} overflow-hidden row ${this.state && this.state.in ? 'in' : 'out'}`}
        onLoad={this.onLoad}
        lazyLoading>
        {this.state && this.state.boost && (
          <>
            <div className="col-md-5 col-lg-4 order-2 order-md-1 mt-5 mt-md-0">
              <div
                className={`wrap position-relative shadow h-100 d-flex flex-wrap rounded-4 px-md-3 py-md-4 px-xl-4 text-white text-center ${this.state.boost.bgColor}`}>
                <div className="col-6 col-md-12 align-self-md-start d-flex flex-wrap border-end border-opacity-50 border-white pe-3 pe-md-0 col1 order-1 position-relative  p-3 pmd-0 pb-md-3">
                  <div
                    className="state-bg"
                    style={{ backgroundImage: `url("${this.state.boost.bgState}"` }}></div>
                  <p className="upOutDownIn w-100 h6">
                    {this.state.boost.city}, {this.state.boost.stateAbbr}
                  </p>
                  <div className="w-100 downOutUpIn">
                    {this.state.boost.boost === 'newly-scorable' ? (
                      <p className="mb-0 h3">Newly Scorable</p>
                    ) : (
                      <>
                        <p className="mb-0 font-weight-bold lh-1 boost-points">
                          {this.state.boost.boost}
                        </p>
                        <p className="mb-0">Point boost</p>
                      </>
                    )}
                  </div>
                </div>
                <div className="col-12 order-3 order-md-2">
                  {this.state.boost.scoreInitial &&
                    this.state.boost.scoreInitial !== this.state.boost.scoreUpgraded && (
                      <div className="d-flex justify-content-center  downOutUpIn align-items-center pb-md-3 border-top border-white border-opacity-50 p-3 p-md-0 upgrade">
                        <div>
                          <div className="body-text-xs text-start">From</div>
                          <div className="badge bg-light text-dark">
                            <span
                              className={`d-inline-block p-1 border-success rounded-circle me-1 me-lg-2 ${setCircleColor(
                                this.state.boost.scoreInitial,
                              )}`}></span>
                            <span className="eyebrow-text">{this.state.boost.scoreInitial}</span>
                          </div>
                        </div>
                        <span className="h6 mb-0 mt-4 ecs-font-icon-nav-arrow-right px-3 px-md-2"></span>
                        <div>
                          <div className="body-text-xs text-start">To</div>
                          <div className="badge bg-light text-dark">
                            <span
                              className={`d-inline-block p-1 rounded-circle me-1 me-lg-2 ${setCircleColor(
                                this.state.boost.scoreUpgraded,
                              )}`}></span>
                            <span className="eyebrow-text">{this.state.boost.scoreUpgraded}</span>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
                <div className="col-6 col-md-12  align-self-md-end p-3 p-md-0 order-2 order-md-3">
                  <p className="fadeIn h6 py-2 py-md-3 border border-white border-end-0 border-start-0 border-opacity-50 account">
                    Accounts added
                  </p>
                  <div className="downOutUpIn">
                    <p className="d-flex justify-content-between body-text-sm">
                      <span>Utility</span>
                      <span>{this.state.boost.utility}</span>
                    </p>
                    <p className="d-flex justify-content-between mb-0 body-text-sm">
                      <span>Telecom</span>
                      <span>{this.state.boost.telcom}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-md-7 col-lg-8 order-md-2 ps-lg-4 ${this.state.boost.bgColor}`}>
              <UsMap />
            </div>
          </>
        )}
      </LazyLoadedComponent>
    );
  }
}

export default BoostMap;
